const STORAGE_KEY_GDPR = "gdpr"

let gdprContainer = document.getElementById("gdpr-container")

let agreed = document.getElementById("gdpr-agreed")
agreed.addEventListener('click', () => {
  localStorage.setItem(STORAGE_KEY_GDPR, true)
  gdprContainer.style.display = "none"
})

let disagreed = document.getElementById("gdpr-disagreed")
disagreed.addEventListener('click', () => {
  localStorage.setItem(STORAGE_KEY_GDPR, false)
  gdprContainer.style.display = "none"
})

let gdpr = localStorage.getItem(STORAGE_KEY_GDPR)
if (gdpr == "true") {
  gdprContainer.style.display = "none"
}
